import store from '@/store/store'

export default {
  methods: {
    failNotification (message) {
      store.state.snackbar = {
        message: message || 'Ha ocurrido un error en el servidor',
        show: true,
        color: 'error'
      }
    },
    warningNotification (message) {
      store.state.snackbar = {
        message,
        show: true,
        color: 'warning'
      }
    },
    successNotification (message) {
      store.state.snackbar = {
        message: message || 'Transacción exitosa',
        show: true,
        color: 'success'
      }
    }
  }
}
